/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Assigned_AgentInputs */

const cs_field_assigned_agent = /** @type {(inputs: Field_Assigned_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přiřazený agent`)
};

const en_field_assigned_agent = /** @type {(inputs: Field_Assigned_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assigned agent`)
};

/**
* | output |
* | --- |
* | "Assigned agent" |
*
* @param {Field_Assigned_AgentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_assigned_agent = /** @type {((inputs?: Field_Assigned_AgentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Assigned_AgentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_assigned_agent(inputs)
	return cs_field_assigned_agent(inputs)
});